<template>
	<div class="card">
		<div
			v-if="!$parent.mobile"
			class="card-body d-flex w-100 align-items-center p-3"
		>
			<slot
				name="title"
			>
				<h6 class="mb-0 text-uppercase font-weight-bold">
					Resultados
					<a-badge
						class="ml-2"
						:count="$parent.data.total"
						:overflow-count="99999"
					/>
					<br>
					<small>Página {{ $parent.page }} de {{ $parent.maxPage }}</small>
				</h6>
			</slot>

			<div class="mr-2" />

			<slot
				name="head-left"
				v-bind="$parent.select"
			/>

			<div class="mr-auto" />

			<slot
				name="head-right"
				v-bind="$parent.select"
			/>

			<a-tooltip
				v-if="$parent.select.length > 0 && !$parent.hideDelete"
				placement="top"
			>
				<template slot="title">
					Borrar {{ $parent.select.length }} registros
				</template>
				<a-popconfirm
					v-if="$gestios.items($parent.app).auth({
						scopes: ['del.mine', 'del'],
						strict: false,
						item: $parent.item
					})"
					:title="`¿Estas seguro que deseas borrar ${$parent.select.length} registros?`"
					@confirm="() => { $parent.deleteItems($parent.select) }"
				>
					<a-button
						:disabled="$parent.loading"
						type="danger"
					>
						<fa-icon
							icon="eraser"
						/>
					</a-button>
				</a-popconfirm>
			</a-tooltip>

			<template v-if="$parent.filtered">
				<div class="mr-2" />

				<a-tooltip placement="top">
					<template slot="title">
						Borrar filtros
					</template>
					<a-button
						:disabled="$parent.loading"
						@click="$parent.cleanFilters"
					>
						<fa-icon
							icon="broom"
						/>
					</a-button>
				</a-tooltip>
			</template>

			<template v-if="!$parent.hideSearch">
				<div class="mr-2" />

				<a-input-search
					v-model="$parent.search"
					:class="$style.search"
					placeholder="Buscar.."
					enter-button
					@search="$parent.setQuerySearch($event)"
				/>
			</template>

			<div
				v-if="!$parent.hideRefresh"
				class="mr-2"
			/>

			<a-tooltip
				v-if="!$parent.hideRefresh"
				placement="top"
			>
				<template slot="title">
					Actualizar
				</template>
				<a-button
					:disabled="$parent.loading"

					@click="$parent.list"
				>
					<fa-icon
						icon="sync-alt"
						:spin="$parent.loading"
					/>
				</a-button>
			</a-tooltip>
		</div>
		<div v-else>
			<div class="card-body pt-3 px-3 pb-0">
				<div class="row">
					<div class="col-12 d-flex align-items-center mb-4">
						<slot
							name="title"
						>
							<h6 class="mb-0 text-uppercase font-weight-bold d-inline-block">
								Resultados
								<a-badge
									class="ml-2"
									:count="$parent.data.total"
									:overflow-count="99999"
								/>
								<br>
								<small>Página {{ $parent.page }} de {{ $parent.maxPage }}</small>
							</h6>
						</slot>

						<template v-if="!$parent.hideRefresh">
							<div class="ml-auto" />

							<a-tooltip placement="top">
								<template slot="title">
									Actualizar
								</template>
								<a-button
									:disabled="$parent.loading"

									@click="$parent.list"
								>
									<fa-icon
										icon="sync-alt"
										:spin="$parent.loading"
									/>
								</a-button>
							</a-tooltip>
						</template>
					</div>
				</div>

				<template v-if="!$parent.hideSearch">
					<div class="row mb-4">
						<div class="col">
							<a-input-search
								v-model="$parent.search"
								placeholder="Buscar.."
								enter-button
								@search="$parent.setQuerySearch($event)"
							/>
						</div>
					</div>
				</template>

				<div class="row d-flex">
					<div class="col mb-3">
						<slot

							name="head-left"
							v-bind="$parent.select"
						/>
					</div>

					<div class="col mb-3">
						<slot
							name="head-right"
							v-bind="$parent.select"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {

};
</script>

<style lang="scss" module>
	.search{
		max-width: 300px;
	}
</style>
